/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import { NavLink, useNavigate, useParams } from 'react-router-dom';
import EnvelopeWithBox from '../components/EnvelopeWithBox';
import Styles from '../css/Glossary.module.css';
import { handleScrollToTop } from '../common/UtilityFunctions';
import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';

const ALPHABET = 'abcdefghijklmnopqrstuvwxyz'.split('');
const GLOSSARY_DATA_URL = 'https://swmc-landingpages.s3.amazonaws.com/myloaninfo_stage/glossary.json';
const fetchGlossaryData = async () => {
  const response = await fetch(GLOSSARY_DATA_URL);
  return response.json();
};

function Glossary() {
  return (
    <EnvelopeWithBox blockName={'Glossary'}>
      <p>Below are definitions of commonly used mortgage banking terms</p>
      <ul className={Styles.glossaryIndexes}>
        <li>Alphabetical&nbsp;Index</li>
        {ALPHABET.map((char) => {
          return (
            <li className={Styles.index}>
              <NavLink
                to={`/glossary/${char}`}
                className={({ isActive }) => (isActive ? Styles.active : Styles.inactive)}
              >
                {char}
              </NavLink>
            </li>
          );
        })}
      </ul>
      <GlossaryIndex />
    </EnvelopeWithBox>
  );
}

function GlossaryIndex() {
  const navigate = useNavigate();
  let { index } = useParams();
  useEffect(() => {
    if (!index) {
      navigate('/glossary/a');
    }
  });
  const { data, isLoading } = useQuery({
    queryKey: ['glossaryData'],
    queryFn: () => fetchGlossaryData(),
  });

  return (
    <dl className={Styles.glossaryList} data-index={index}>
      {isLoading ? (
        <>
          <dt>{index}:</dt> <dd>loading records...</dd>
        </>
      ) : Object.entries(data[index] || {}).length === 0 ? (
        <>
          <dt></dt> <dd>No records exist for this index</dd>
          <br />
        </>
      ) : (
        Object.entries<String>(data[index]).map(([key, value]) => {
          return (
            <>
              <dt>{key}:</dt> <dd>{value}</dd>
              <br />
              <br />
            </>
          );
        })
      )}
      <button className={Styles.scrollButton} onClick={handleScrollToTop}>
        &lt; Return to Top
      </button>
    </dl>
  );
}

export default Glossary;
